import PropTypes from 'prop-types';

const InputFieldTextSuffix = ({ children = null }) => children;

InputFieldTextSuffix.propTypes = {
  children: PropTypes.node,
};

export default InputFieldTextSuffix;
